import { registerComponent } from "lib/components";
import { UserTitleRoleEditorApp } from "./main";

registerComponent({ UserTitleRoleEditorApp });
